module.exports = __webpack_public_path__ + "static/media/br_middle.9eeccff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/index/img/br_middle.png
// module id = 1503
// module chunks = 0